import {
  Button,
  Divider,
  Flex,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaPlus } from 'react-icons/fa6';
import { useCallback } from 'react';
import { Link, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import usePermissionStatusByKey from '../../../../hooks/usePermissionStatusByKey';

const BasePricesLayout = ({ availableTabs, children }) => {
  const { path, url } = useRouteMatch();
  const location = useLocation();
  const history = useHistory();
  const borderColor = useColorModeValue('blue.50', 'rgba(255, 255, 255, 0.10)');

  const textColor = useColorModeValue('gray.700', 'white');

  const isCreateBasePrice = usePermissionStatusByKey('POST:/admin/base-prices');
  const isCreateNextBasePrice = usePermissionStatusByKey(
    'POST:/admin/next-base-prices',
  );

  const pageConfig = {
    '/base-prices': {
      title: 'Base Prices',
      createUrl: '/base-prices/new',
      canCreate: isCreateBasePrice,
    },
    '/base-prices/next-base-prices': {
      title: 'Scheduled Base Prices',
      createUrl: '/base-prices/next-base-prices/new',
      canCreate: isCreateNextBasePrice,
    },
  };

  const currentPage =
    pageConfig[location.pathname] || pageConfig['/base-prices'];

  const onNewButtonClicked = useCallback(() => {
    history.push(currentPage.createUrl);
  }, [history, currentPage.createUrl]);

  return (
    <>
      <Flex justifyContent="space-between" alignItems="center" mb={3}>
        <Text
          fontSize="40px"
          fontStyle="normal"
          fontWeight="700"
          color={textColor}
          mb="0px"
          className="page-name"
        >
          {currentPage.title}
        </Text>
        {currentPage.canCreate && (
          <Button
            variant="submit-ms"
            maxW="140px"
            w="100%"
            onClick={onNewButtonClicked}
            leftIcon={<FaPlus />}
          >
            Create
          </Button>
        )}
      </Flex>

      <Flex
        align="left"
        mb={{ sm: '10px', md: '0px' }}
        direction={{ sm: 'column', md: 'row' }}
        w={{ sm: '100%' }}
        textAlign={{ sm: 'center', md: 'start' }}
        borderBottom="1px"
        borderColor={borderColor}
        className="settings-tabs"
      >
        {availableTabs.includes('/') && (
          <Link
            to={'/base-prices'}
            className={
              location.pathname === '/base-prices' ? 'settings-tab-active' : ''
            }
          >
            Base Prices
          </Link>
        )}
        {availableTabs.includes('/next-base-prices') && (
          <Link
            to={'/base-prices/next-base-prices'}
            className={
              location.pathname === '/base-prices/next-base-prices'
                ? 'settings-tab-active'
                : ''
            }
          >
            Scheduled Base Prices
          </Link>
        )}
      </Flex>
      <Divider
        opacity="1"
        mr="2px"
        borderColor={borderColor}
        borderTopWidth="1px"
        borderBottomWidth="0"
        mb="32px"
      />

      {children}
    </>
  );
};

export default BasePricesLayout;
